import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";

import { urls } from "client/routes";
import TextButton from "client/common/components/buttons/TextButton";

import Tooltip from "./Tooltip";

import styles from "../../styles/PrivacyDisclaimerTooltip.module.less";

type PrivacyDisclaimerTooltipProps = {
  children: React.ReactNode;
};

const PrivacyDisclaimerContent = (
  <span>
    Some of the information you provide may be considered sensitive under state privacy laws. We
    process this information solely for your provider and under their instructions, such as for
    verification or legal compliance purposes. This information is required to provide the requested
    service. By continuing, you consent to its collection and use for this purpose. See our{" "}
    <TextButton dest={urls.support.privacyPolicy()} hasUnderline={true} newTab={true}>
      Privacy Policy
    </TextButton>{" "}
    for more information.
  </span>
);

const PrivacyDisclaimerTooltip = ({ children }: PrivacyDisclaimerTooltipProps) => {
  return (
    <span className={styles.container}>
      {children}
      <Tooltip
        content={PrivacyDisclaimerContent}
        isEnabled={true}
        position="below"
        align="right"
        className={styles.tooltip}
        popoverClassName={styles.tooltipPopover}
        elementType="span"
      >
        <Icon icon={faQuestionCircle} className={styles.icon} />
      </Tooltip>
    </span>
  );
};

export default PrivacyDisclaimerTooltip;
